const isOpen = ref(false);

export function useGasCalculator() {
  return {
    isOpen,
    open()  { isOpen.value = true; },
    close() { isOpen.value = false; },
  };
}
